import { gql } from '@apollo/client';

export const serviceLevelRacewayFragments = {
  serviceLevelRacewayItem: gql`
    fragment ServiceLevelRacewayItem on ServiceLevelRaceway {
      id
      name
      description
      trayFillMethod
      trayOverfillMethod
      trayMaxFillLimit
      conduitFillMethod
      conduitOverfillMethod
      conduitMaxFillLimit
      channelFillMethod
      channelOverfillMethod
      channelMaxFillLimit
      transitFillMethod
      transitOverfillMethod
      transitMaxFillLimit
      specialFillMethod
      specialOverfillMethod
      specialMaxFillLimit
      engineeringStatus
      updatedBy
      updatedTime
      updatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      preparedTime
      preparedBy
      preparedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      checkedTime
      checkedBy
      checkedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      approvedTime
      approvedBy
      approvedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
    }
  `,
};

export const GET_SERVICE_LEVEL_RACEWAY_BY_ID = gql`
  ${serviceLevelRacewayFragments.serviceLevelRacewayItem}
  query ServiceLevelRacewayById($id: ID!) {
    serviceLevelRacewayById(id: $id) {
      ...ServiceLevelRacewayItem
    }
  }
`;

export const SEARCH_SERVICE_LEVEL_RACEWAY = gql`
  ${serviceLevelRacewayFragments.serviceLevelRacewayItem}
  query SearchServiceLevelRaceways($searchInput: SearchInput) {
    searchServiceLevelRaceways(searchInput: $searchInput) {
      items {
        ...ServiceLevelRacewayItem
      }
    }
  }
`;

export const UPDATE_SERVICE_LEVEL_RACEWAYS = gql`
  ${serviceLevelRacewayFragments.serviceLevelRacewayItem}
  mutation UpdateServiceLevelRaceway($updateServiceLevelRacewayInput: [UpdateServiceLevelRacewayInput!]!) {
    updateServiceLevelRaceway(updateServiceLevelRacewayInput: $updateServiceLevelRacewayInput) {
      serviceLevelRaceways {
        ...ServiceLevelRacewayItem
      }
      errors
    }
  }
`;

export const ISSUE_SERVICE_LEVEL_RACEWAYS = gql`
  ${serviceLevelRacewayFragments.serviceLevelRacewayItem}
  mutation IssueServiceLevelRaceways($issueServiceLevelRacewayInput: IssueServiceLevelRacewayInput!) {
    issueServiceLevelRaceways(issueServiceLevelRacewayInput: $issueServiceLevelRacewayInput) {
      serviceLevelRaceways {
        ...ServiceLevelRacewayItem
      }
      errors {
        messageKeys
      }
    }
  }
`;
